export const ROLES = {
  SuperAdmin: 'SUPER_ADMIN',
};

export const ROLES_KEYS = {
  SUPER_ADMIN: 'Super Admin',
};

export const STATUS = {
  SUCCESS: 'success',
  ERROR: 'error',
  INFO: 'info',
  WARNING: 'warning',
};

export const initialPaginationConfig = { page: 1, pageSize: 10 };

export const TABLE_ROWS = [10, 50, 100];

export const USER_ACTIVITY_KEYS = {
  DAILY_ACTIVE_USERS: 'DAILY_ACTIVE_USERS',
  MONTHLY_ACTIVE_USERS: 'MONTHLY_ACTIVE_USERS',
  DELETED: 'DELETED',
};

export const USER_ACTIVITY_ACTIONS = {
  REACTIVE: 'REACTIVE',
  SEND_INVITATION: 'SEND_INVITATION',
};

export const USER_ROLES = {
  EMPLOYER: 'EMPLOYER',
  JOBSEEKER: 'JOB_SEEKER',
};

export const rolesKey = {
  jobSeekers: 'Job Seeker',
  employers: 'Employer',
};

export const TESTIMONIAL_TYPE = {
  REGISTERED: 'REGISTERED',
  CUSTOM: 'CUSTOM',
};

/**
 * Feature categories a subscription package may offer. Provisioning, quota lookups and the screens a
 * package unlocks all key on the category, so it is the unit the admin configures.
 */
export const FEATURE_CATEGORY = {
  JOB_POSTING: 'JOB_POSTING',
  CAMPAIGN: 'CAMPAIGN',
  THIRD_PARTY: 'THIRD_PARTY',
};

/** How a package's feature for a category is sourced: reused from the catalogue, or declared fresh. */
export const FEATURE_MODE = {
  EXISTING: 'EXISTING',
  NEW: 'NEW',
};

export const INVOICE_PLAN_TYPE = {
  REGULAR: 'REGULAR',
  CUSTOM: 'CUSTOM',
};

export const INVOICE_PAYMENT_MODE = {
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE',
};

export const INVOICE_PAYMENT_STATUS = {
  PAID: 'PAID',
};

export const PAYMENT_MODE_TAG_COLOR = {
  ONLINE: 'processing',
  OFFLINE: 'default',
};

export const PAYMENT_STATUS_TAG_COLOR = {
  PAID: 'success',
};

export const CAMPAIGN_TABS = {
  CAMPAIGN_OVERVIEW: 'CAMPAIGN_OVERVIEW',
  UPCOMING_CALLS: 'UPCOMING_CALLS',
};

export const CAMPAIGN_STATUS_COLORS = {
  ACTIVE: 'success',
  COMPLETED: 'blue',
  PAUSE: 'warning',
};
